import _ from "lodash";

export const isLoggedIn = (state) => {
    return !_.isEmpty(state.user)
}
